import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  tableCellClasses,
  Autocomplete,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
  Select,
  Divider,
  Chip,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Container } from 'reactstrap';
import axios from '../../utils/axios';
import UIContext from '../../context/UIContext';
import NoResultsFound from '../../components/NoResultsFound';

const StyledTableCell = styled(TableCell)({
  color: '#424242',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(238, 238, 238)',
  },
});

const sourcingOption = [
  { label: 'Export', value: 'Export' },
  { label: 'Envelope', value: 'Envelope' },
  { label: 'Import', value: 'Import' },
  { label: 'IP', value: 'IP' },
  { label: 'PAC', value: 'PAC' },
  { label: 'Ticket', value: 'Ticket' },
];

const CargoRate = () => {
  const [filterInputs, setFilterInputs] = useState({
    country: 0,
    sourcing: 'all',
    minWeight: '',
    maxWeight: '',
  });

  const cargoRateInitailValue = {
    cargoRateid: 0,
    country: 0,
    sourcing: '',
    minCBM: '',
    maxCBM: '',
    rate: '',
    profit: '',
    duty: '',
    actualRate: '',
  };

  const [cargoRateTableData, setCargoRateTableData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [initialValue, setInitialValue] = useState(cargoRateInitailValue);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [deleteCargoRate, setDeleteCargoRate] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [edit, setEdit] = useState(false);
  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    getAllCargoRate();
    getAllHelpData();
  }, []);

  const userValidationSchema = useMemo(
    () =>
      Yup.object().shape({
        // country: Yup.object().required('Select Country '),
        // sourcing: Yup.string().required('Select Sourcing'),
        minCBM: Yup.number()
          .required('Enter min CBM')
          .test('is-decimal', 'must have at most 2 decimal places', (value) => /^\d+(\.\d{1,2})?$/.test(value)),
        maxCBM: Yup.number()
          .required('Enter max CBM')
          .test('is-decimal', 'must have at most 2 decimal places', (value) => /^\d+(\.\d{1,2})?$/.test(value)),
        rate: Yup.number()
          .required('Enter Rate')
          .test('is-decimal', 'must have at most 2 decimal places', (value) => /^\d+(\.\d{1,2})?$/.test(value)),
        profit: Yup.number()
          .required('Enter Profit')
          .test('is-decimal', 'must have at most 2 decimal places', (value) => /^\d+(\.\d{1,2})?$/.test(value)),
        duty: Yup.number().test(
          'is-decimal',
          'Must have at most 2 decimal places',
          (value) => !value || /^\d+(\.\d{1,2})?$/.test(value) // Validate only when a value exists
        ),
      }),
    []
  );

  const getAllHelpData = async () => {
    try {
      const countryRes = await axios.get('master/country/getcountrylist');
      const updatedCountryList = [{ CountryId: '0', CountryName: 'All' }, ...countryRes.data];
      setCountryList(updatedCountryList);
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
  };

  const getAllCargoRate = async () => {
    try {
      showLoading();
      const response = await axios.get(
        `master/cargorate/getallcargorate/${filterInputs.country?.CountryId || 0}/${filterInputs.sourcing}/${filterInputs.minWeight || 0
        }/${filterInputs.maxWeight || 0}`
      );
      if (response.data.length > 0) {
        setCargoRateTableData(response.data);
      } else {
        setCargoRateTableData([]);
      }
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const SaveCargoRate = async ({ country, ...values }, resetForm, setFieldValue) => {
    if (!edit) {
      if (
        filterInputs.country.CountryName === 'All' ||
        filterInputs.country.CountryId === '0' ||
        !filterInputs.country
      ) {
        window.alert('Select a valid Country');
        openSnackBar('Select a valid Country', 'error');
        return;
      }
      if (filterInputs.sourcing === 'all' || filterInputs.sourcing === '') {
        window.alert('Select a valid Sourcing option');
        openSnackBar('Select a valid Sourcing option', 'error');
        return;
      }
    }
    // Prepare payload dynamically
    const payload = {
      ...values,
      countryId: edit ? country.CountryId : filterInputs.country.CountryId,
      countryName: edit ? country.CountryName : filterInputs.country.CountryName,
      actualRate: Number(values.profit) + Number(values.duty) + Number(values.rate),
      [!edit ? 'createdBy' : 'modifiedBy']: sessionStorage.getItem('UserId'),
    };

    if (!edit) {
      // Add sourcing only when not in edit mode
      payload.sourcing = filterInputs.sourcing;
    }

    try {
      showLoading();
      await axios.post(`master/cargorate/${!edit ? 'addcargorate' : 'updatecargorate'}`, payload);
      getAllCargoRate();
      setEdit(false);
      setOpen(false);
      // resetForm();
      // setInitialValue(cargoRateInitailValue2)
      setFieldValue('minCBM', '')
      setFieldValue('maxCBM', '')
      setFieldValue('rate', '')
      setFieldValue('profit', '')
      setFieldValue('duty', '')
      setFieldValue('actualRate', '')
      openSnackBar(`${!edit ? 'Added' : 'Updated'} Successfully`);
      handleClose();
    } catch (e) {
      openSnackBar('Something went wrong', 'error');
    }
    hideLoading();
  };

  const DeleteCargoRate = async () => {
    try {
      showLoading();
      await axios.delete(`master/cargorate/DeleteCargoRate/${deleteCargoRate}`);
      getAllCargoRate();
      openSnackBar(`Deleted Successfully`);
      handleCloseDelete();
    } catch (e) {
      openSnackBar('Something went wrong', 'error');
    }
    hideLoading();
  };

  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = cargoRateTableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [cargoRateTableData, page, rowsPerPage]);

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteCargoRate(null);
  };

  const handleClose = () => {
    setEdit(false);
    setOpen(false);
    // setInitialValue(cargoRateInitailValue);
  };

  const handleFilterInputs = (e) => {
    setFilterInputs({
      ...filterInputs,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: '#8EACCD',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              CARGO RATE MASTER
            </Typography>
          </Typography>
        </Grid>
        <Formik
          validationSchema={userValidationSchema}
          initialValues={initialValue}
          onSubmit={async (values, { resetForm, setFieldValue }) => {
            await SaveCargoRate({ ...initialValue, ...values }, resetForm, setFieldValue);
          }}
          style={{ padding: '0', margin: '0' }}
        >
          {({
            submitForm,
            setFieldValue,
            touched,
            values,
            errors,
            handleChange,
            handleBlur,
            isSubmitting,
          }) => (
            <Form>
              <Grid container justifyContent="center" spacing={2} p={1} pt={0} my={1} rowSpacing={1} columnSpacing={2}>
                <Grid item xs={12}>
                  <Divider variant="middle">
                    <Chip label="Filters" size="small" color="primary" variant="outlined" />
                  </Divider>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={countryList}
                    getOptionLabel={(country) => country.CountryName || ''}
                    isOptionEqualToValue={(value) => value.Countryid === filterInputs.country.CountryId}
                    renderOption={(props, country) => (
                      <li {...props} key={country.CountryId}>
                        {country.CountryName}
                      </li>
                    )}
                    name="country"
                    // value={filterInputs.country}
                    value={filterInputs.country || countryList.find((c) => c.CountryId === '0') || null}
                    onChange={(event, value) => {
                      setFieldValue('country', value);
                      setFilterInputs({
                        ...filterInputs,
                        country: value,
                      });
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <span>
                            Country <span style={{ color: 'red' }}>*</span>
                          </span>
                        }
                        placeholder="Select Country"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        size="small"
                        error={touched.country && !!errors.country}
                        helperText={touched.country && errors.country}
                      />
                    )}
                    disableClearable
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <TextField
                    fullWidth
                    select
                    label="Sourcing"
                    name="sourcing"
                    value={filterInputs.sourcing || ''}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {[{ value: 'all', label: 'All' }, ...sourcingOption].map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={2} xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Min CBM"
                    type="number"
                    name="minWeight"
                    onWheel={(e) => e.target.blur()}
                    value={filterInputs.minWeight}
                    onChange={handleFilterInputs}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Max CBM"
                    type="number"
                    name="maxWeight"
                    onWheel={(e) => e.target.blur()}
                    value={filterInputs.maxWeight}
                    onChange={handleFilterInputs}
                  />
                </Grid>
                <Grid item md={1} xs={12} sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <Button variant="contained" color="primary" sx={{ boxShadow: 1 }} onClick={getAllCargoRate} fullWidth>
                    View
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  <Divider variant="middle">
                    <Chip label="Add New Record" size="small" color="primary" variant="outlined" />
                  </Divider>
                </Grid>
                <Grid item md={2} xs={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label={
                      <span>
                        Min CBM <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    name="minCBM"
                    value={values.minCBM}
                    onBlur={handleBlur}
                    error={touched.minCBM && !!errors.minCBM}
                    helperText={touched.minCBM && errors.minCBM}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item md={2} xs={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label={
                      <span>
                        Max CBM <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    name="maxCBM"
                    value={values.maxCBM}
                    onBlur={handleBlur}
                    error={touched.maxCBM && !!errors.maxCBM}
                    helperText={touched.maxCBM && errors.maxCBM}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item md={2} xs={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label={
                      <span>
                        Rate <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    name="rate"
                    onBlur={handleBlur}
                    error={touched.rate && !!errors.rate}
                    helperText={touched.rate && errors.rate}
                    value={values.rate}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item md={2} xs={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Duty"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    name="duty"
                    onBlur={handleBlur}
                    error={touched.duty && !!errors.duty}
                    helperText={touched.duty && errors.duty}
                    value={values.duty}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item md={2} xs={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label={
                      <span>
                        Profit <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    type="number"
                    name="profit"
                    onWheel={(e) => e.target.blur()}
                    onBlur={handleBlur}
                    error={touched.profit && !!errors.profit}
                    helperText={touched.profit && errors.profit}
                    value={values.profit}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item md={2} xs={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Actual Rate"
                    disabled
                    type="number"
                    name="actualRate"
                    onWheel={(e) => e.target.blur()}
                    value={(Number(values.profit) + Number(values.duty) + Number(values.rate)).toFixed(2)}
                  />
                </Grid>
                <Grid item md={1} xs={12}>
                  <Button
                    onClick={submitForm}
                    disabled={isSubmitting}
                    variant="contained"
                    color="success"
                    sx={{ boxShadow: 1 }}
                    fullWidth
                  >
                    {!edit ? 'Add' : 'Update'}
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
        {cargoRateTableData.length === 0 && <NoResultsFound />}
        {cargoRateTableData.length > 0 && (
          <>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">S.No</StyledTableCell>
                    <StyledTableCell align="left">Country</StyledTableCell>
                    <StyledTableCell align="left">Sourcing</StyledTableCell>
                    <StyledTableCell align="right">MIN CBM</StyledTableCell>
                    <StyledTableCell align="right">MAX CBM</StyledTableCell>
                    <StyledTableCell align="right">Rate</StyledTableCell>
                    <StyledTableCell align="right">Duty</StyledTableCell>
                    <StyledTableCell align="right">Profit</StyledTableCell>
                    <StyledTableCell align="right">Actual Rate</StyledTableCell>
                    <StyledTableCell align="center">Actions</StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? cargoRateTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : cargoRateTableData
                  ).map((cargoRate, i) => (
                    <TableRow key={cargoRate.cargoRateId} hover>
                      <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                      <TableCell align="left">{cargoRate.countryName}</TableCell>
                      <TableCell align="left">{cargoRate.sourcing}</TableCell>
                      <TableCell align="right">{cargoRate.minCBM}</TableCell>
                      <TableCell align="right">{cargoRate.maxCBM}</TableCell>
                      <TableCell align="right">{cargoRate.rate}</TableCell>
                      <TableCell align="right">{cargoRate.duty || '-'}</TableCell>
                      <TableCell align="right">{cargoRate.profit}</TableCell>
                      <TableCell align="right">{cargoRate.actualRate}</TableCell>
                      <TableCell align="center" sx={{ padding: '0' }}>
                        <IconButton
                          aria-label="Edit"
                          onClick={() => {
                            setEdit(true);
                            setInitialValue({
                              ...cargoRate,
                              country: countryList.find((con) => con.CountryId === cargoRate.countryId),
                            });
                            setOpen(true);
                          }}
                        >
                          <EditIcon color="primary" />
                        </IconButton>
                        <IconButton
                          aria-label="Delete"
                          onClick={() => {
                            setDeleteCargoRate(cargoRate.cargoRateId);
                            setOpenDelete(true);
                          }}
                        >
                          <DeleteForeverIcon color="error" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={11} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage} // Use the calculated currentPage value
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0); // Reset the page when rowsPerPage changes
              }}
              mt={2}
            />
          </>
        )}

        <Grid m={2}>
          {/* add new popup form dialog box */}
          <Dialog maxWidth={'md'} open={open} onClose={handleClose} fullWidth>
            <Container component={Paper} elevation={2} sx={{ p: 4 }}>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h5" textAlign={'left'} p={2} fontWeight={600} color="primary">
                  {!edit ? 'Add' : 'Edit'} Cargo Rate
                </Typography>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>

              <Formik
                validationSchema={userValidationSchema}
                initialValues={initialValue}
                onSubmit={async (values, { resetForm, setFieldValue }) => {
                  await SaveCargoRate({ ...initialValue, ...values }, resetForm, setFieldValue);
                }}
              >
                {({ submitForm, setFieldValue, touched, values, errors, handleChange, handleBlur, isSubmitting }) => (
                  <Form>
                    <Grid container justifyContent="center" spacing={2} p={2} rowSpacing={2} columnSpacing={2}>
                      <Grid item md={4} xs={12}>
                        <Autocomplete
                          options={countryList}
                          getOptionLabel={(country) => country.CountryName || ''}
                          isOptionEqualToValue={(value) => value.CountryId === values.country.CountryId}
                          renderOption={(props, country) => (
                            <li {...props} key={country.CountryId}>
                              {country.CountryName}
                            </li>
                          )}
                          name="country"
                          value={values.country || null}
                          onChange={(event, value) => {
                            setFieldValue('country', value);
                          }}
                          size="small"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={
                                <span>
                                  Country <span style={{ color: 'red' }}>*</span>
                                </span>
                              }
                              placeholder="Select Country"
                              variant="outlined"
                              InputLabelProps={{ shrink: true }}
                              size="small"
                              error={touched.country && !!errors.country}
                              helperText={touched.country && errors.country}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        {/* Status Filter */}
                        <FormControl
                          fullWidth
                          variant="outlined"
                          size="small"
                          error={touched.sourcing && !!errors.sourcing}
                        >
                          <InputLabel shrink="true" sx={{ backgroundColor: 'white', px: 1 }}>
                            Sourcing <span style={{ color: 'red' }}>*</span>
                          </InputLabel>
                          <Select
                            name="sourcing"
                            value={values.sourcing}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            displayEmpty
                            sx={{
                              opacity: !values.sourcing ? 0.65 : 1,
                            }}
                          >
                            <MenuItem sx={{ display: 'none' }} value="" disabled>
                              Select Sourcing
                            </MenuItem>

                            {sourcingOption.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>{touched.sourcing && errors.sourcing}</FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item md={2} xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          label={
                            <span>
                              Min CBM <span style={{ color: 'red' }}>*</span>
                            </span>
                          }
                          type="number"
                          name="minCBM"
                          value={values.minCBM}
                          onBlur={handleBlur}
                          onWheel={(e) => e.target.blur()}
                          error={touched.minCBM && !!errors.minCBM}
                          helperText={touched.minCBM && errors.minCBM}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item md={2} xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          label={
                            <span>
                              Max CBM <span style={{ color: 'red' }}>*</span>
                            </span>
                          }
                          type="number"
                          name="maxCBM"
                          value={values.maxCBM}
                          onBlur={handleBlur}
                          onWheel={(e) => e.target.blur()}
                          error={touched.maxCBM && !!errors.maxCBM}
                          helperText={touched.maxCBM && errors.maxCBM}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item md={2} xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          label={
                            <span>
                              Rate <span style={{ color: 'red' }}>*</span>
                            </span>
                          }
                          type="number"
                          name="rate"
                          onBlur={handleBlur}
                           onWheel={(e) => e.target.blur()}
                          error={touched.rate && !!errors.rate}
                          helperText={touched.rate && errors.rate}
                          value={values.rate}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item md={2} xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          label={
                            <span>
                              Profit <span style={{ color: 'red' }}>*</span>
                            </span>
                          }
                          type="number"
                          name="profit"
                          onBlur={handleBlur}
                           onWheel={(e) => e.target.blur()}
                          error={touched.profit && !!errors.profit}
                          helperText={touched.profit && errors.profit}
                          value={values.profit}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item md={2} xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Duty"
                          type="number"
                          name="duty"
                          onBlur={handleBlur}
                          onWheel={(e) => e.target.blur()}
                          error={touched.duty && !!errors.duty}
                          helperText={touched.duty && errors.duty}
                          value={values.duty}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item md={2} xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Actual Rate"
                          disabled
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          name="actualRate"
                          value={(Number(values.profit) + Number(values.duty) + Number(values.rate)).toFixed(2)}
                        />
                      </Grid>

                      <Grid item md={4} xs={6}>
                        <Stack
                          direction="row"
                          justifyContent="center"
                          mt={1}
                          alignItems={'center'}
                          gap={2}
                          sx={{ textAlign: 'center' }}
                        >
                          <Button
                            onClick={handleClose}
                            variant="contained"
                            color="error"
                            size="small"
                            sx={{ boxShadow: 1 }}
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={submitForm}
                            disabled={isSubmitting}
                            variant="contained"
                            color="primary"
                            size="small"
                            sx={{ boxShadow: 1 }}
                          >
                            {!edit ? 'Save' : 'Update'}
                          </Button>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Container>
          </Dialog>
        </Grid>

        {/* confirmation dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete} fullScreen={fullScreen} fullWidth maxWidth="xs">
          <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={DeleteCargoRate} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default CargoRate;
